export const parseSearchPriceList = (prices) => {
  return prices.map((price) => ({
    id: price.id,
    text: price.attributes?.description,
    price: price.attributes?.total_excluding_vat,
    vatCodeId: price.vat_code?.id,
    currency: price.currency?.attributes?.code,
  }));
};
